export function algorithmOrderAdapter(data) {
    return {
        id: data === null || data === void 0 ? void 0 : data.id,
        orderId: data === null || data === void 0 ? void 0 : data.orderId,
        status: data === null || data === void 0 ? void 0 : data.status,
        type: data === null || data === void 0 ? void 0 : data.type,
        side: data === null || data === void 0 ? void 0 : data.side,
        price: data === null || data === void 0 ? void 0 : data.price,
        quantity: data === null || data === void 0 ? void 0 : data.quantity,
        duration: data === null || data === void 0 ? void 0 : data.duration,
        spread: data === null || data === void 0 ? void 0 : data.spread,
        canceledTime: data === null || data === void 0 ? void 0 : data.canceledTime,
        createdAt: data === null || data === void 0 ? void 0 : data.createdAt,
        spreadPercentage: data.spreadPercentage,
        spreadData: data.spreadData,
        closedOrder: data.closedOrder,
        createTime: data.createTime,
        account: data.account,
        executedQuantity: data.executedQuantity,
        isSelfBuy: data.isSelfBuy,
        reason: data.reason,
        countLeft: data.countLeft,
        profit: data.profit,
        pairId: data.pairId
    };
}
